import React from "react";

const IconBookProduct = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 32.502 37.105">
      <g
        id="Group_2046"
        dataname="Group 2046"
        transform="translate(343.221 -9.213)"
      >
        <rect
          id="Rectangle_2519"
          dataname="Rectangle 2519"
          width="29.566"
          height="35.915"
          rx="4.565"
          transform="translate(-340.88 9.808)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.19"
        />
        <g
          id="Group_2044"
          dataname="Group 2044"
          transform="translate(-337.512 27.849) rotate(-45)"
        >
          <g
            id="Group_2042"
            dataname="Group 2042"
            transform="translate(0 7.127)"
          >
            <path
              id="Path_9338"
              dataname="Path 9338"
              d="M-324.025,27.266h-2.727a2.837,2.837,0,0,1-2.829-2.828h0a2.837,2.837,0,0,1,2.829-2.828h2.727"
              transform="translate(340.052 -21.61)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.19"
            />
            <line
              id="Line_142"
              dataname="Line 142"
              x1="16.262"
              transform="translate(0 2.828)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.19"
            />
          </g>
          <g
            id="Group_2043"
            dataname="Group 2043"
            transform="translate(4.392)"
          >
            <line
              id="Line_143"
              dataname="Line 143"
              y2="9.278"
              transform="translate(2.39 6.748)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.19"
            />
            <ellipse
              id="Ellipse_221"
              dataname="Ellipse 221"
              cx="2.458"
              cy="3.266"
              rx="2.458"
              ry="3.266"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.19"
            />
          </g>
        </g>
        <g
          id="Group_2045"
          dataname="Group 2045"
          transform="translate(-342.626 17.308)"
        >
          <line
            id="Line_144"
            dataname="Line 144"
            x2="3.424"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.19"
          />
          <line
            id="Line_145"
            dataname="Line 145"
            x2="3.424"
            transform="translate(0 5.229)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.19"
          />
          <line
            id="Line_146"
            dataname="Line 146"
            x2="3.424"
            transform="translate(0 10.457)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.19"
          />
          <line
            id="Line_147"
            dataname="Line 147"
            x2="3.424"
            transform="translate(0 15.686)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.19"
          />
          <line
            id="Line_148"
            dataname="Line 148"
            x2="3.424"
            transform="translate(0 20.915)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.19"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconBookProduct;
